import { convertQueryCommandToQueryString, IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { ITourUserHasExceptions } from '@llws/lift-entity-interfaces';
import { IRemovePayload } from '@/shared';
import { adminRequest } from '@/shared/request-configs/admin-request';
import vm from '@/main';
import { ITourUserExceptionPayload } from '@/shared/interfaces/tours';
import { IAction, IStateStrict } from '@/shared/interfaces/store-base';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';

interface IToursState {
  tourUserHasExceptions: Array<ITourUserHasExceptions>,
}

// Base store configuration
const agentGatewayResourcePathAgent: string = '/tour-api-agent';
const adminGatewayResourcePathAdmin: string = '/tour-api-admin';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {};

const defaultGetSingleFilters: IQueryCommandOptions = {};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<ITourUserHasExceptions>({
  adminGatewayResourcePath: adminGatewayResourcePathAdmin,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

const tourUserExceptionsFilters: IQueryCommandOptions = {
  limit: 999,
};

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
    tourUserHasExceptions: [] as Array<ITourUserHasExceptions>,
  },

  getters: {
    ...base.getters,

    tourUserHasExceptions(state: IToursState): ITourUserHasExceptions[] {
      return state.tourUserHasExceptions ? state.tourUserHasExceptions : [];
    },
  },

  mutations: {
    ...base.mutations,
    setTourUserHasExceptions(state: IToursState, payload: Array<ITourUserHasExceptions>) {
      state.tourUserHasExceptions = payload;
    },
  },

  actions: {
    ...base.actions,
    getTourUserExceptions: async (ctx: IAction<IStateStrict<ITourUserHasExceptions>>, payload: IQueryCommandOptions) => {
      const filters: IQueryCommandOptions = payload ? { ...tourUserExceptionsFilters, ...payload } : tourUserExceptionsFilters;
      const response = await adminRequest.get(`${vm()?.$rsGlobals.$hasToursRestricted() ? agentGatewayResourcePathAgent : adminGatewayResourcePathAdmin}/tour_user_exceptions${convertQueryCommandToQueryString(filters)}`);
      ctx.commit('setTourUserHasExceptions', response.data);
    },
    insertUserException: async (_ctx: IAction<IStateStrict<ITourUserHasExceptions>>, payload: ITourUserExceptionPayload) => {
      const response = await adminRequest.post(`${vm()?.$rsGlobals.$userHasAtLeastOneAccess('tour_admins', 'read') ? adminGatewayResourcePathAdmin : agentGatewayResourcePathAgent}/tour_user_exceptions`, payload);
      return response.data;
    },
    deleteUserException: async (_ctx: IAction<IStateStrict<ITourUserHasExceptions>>, payload: IRemovePayload) => {
      const response = await adminRequest.delete(`${vm()?.$rsGlobals.$userHasAtLeastOneAccess('tour_admins', 'read') ? adminGatewayResourcePathAdmin : agentGatewayResourcePathAgent}/tour_user_exceptions`, [payload.id]);
      return response.data;
    },
  },
};
